import { callApi } from "utils/api";
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const entity = 'super_admin'
const messageEntity = 'el socio'
const messagePluralEntity = 'los socios'

const add = (item, options = {}) => {

  const { showMessage = true } = options

  return async (dispatch, getState) => {
    const state = getState()
    const lang = state.app.lang
    //  It first add the Item
    let messages = {
      en: {
        success: `${messageEntity} has been added successfully`
      },
      es: {
        success: `Se agregó ${messageEntity} correctamente.`
      },
    }
    const successMsg = messages[lang]?.success ?? messages['es']?.success ?? `${messageEntity} added successfully`

    let res = await callApi(`/${entity}`, {
      method: 'POST',
      body: JSON.stringify(item),
      headers: {
        token: state.app?.superAdmin?.token
      },
      successMessage: showMessage ? successMsg : undefined
    })

    let stored_item = res.body

    dispatch({
      type: `ADD_${entity.toUpperCase()}`,
      response: stored_item
    })
    
    return res.body;
  }
}

const load = (options = {}) => {
  const { page = 1, limit = 50, force = false } = options

  return async (dispatch, getState) => {
    const state = getState();
    const cacheKey = `super_admin_page_${page}`
    const cache = state.super_admins?._cache?.[cacheKey]

    if (!force && cache && Date.now() - cache.cachedAt < 5 * 60 * 1000) {
      return
    }

    dispatch({ type: `FETCH_SUPER_ADMINS` })
    const params = { paginated: 'true', page, limit, order_by: 'id:ASC', ...(options.params || {}) }
    const res = await callApi(`/${entity}`, {
      method: 'GET',
      headers: { token: state.app?.superAdmin?.token },
      params,
    })

    const payload = res.body?.data ? res.body : { data: res.body, pagination: res.body?.pagination }
    dispatch({
      type: `LOAD_${entity.toUpperCase()}S`,
      payload: { ...payload, page, silent: options.silent || false, cachedAt: Date.now() },
    })
    return res.body;
  }
}

const prefetchNext = () => {
  return async (dispatch, getState) => {
    const state = getState()
    const cp = state.super_admins?._pagination?.current_page || 1
    const tp = state.super_admins?._pagination?.total_pages || 1
    if (cp >= tp) return
    dispatch(load({ page: cp + 1, limit: 50, silent: true, force: true }))
  }
}

const invalidate = () => ({
  type: 'INVALIDATE_SUPER_ADMINS',
})

const get = (id, options = {}) => {
  return async (dispatch, getState) => {
    const state = getState();
    dispatch({
      type: `FETCH_${entity.toUpperCase()}S`,
    })

    const res = await callApi(`/${entity}/${id}`, {
      method: 'GET',
      headers: {
        token: state.app?.superAdmin?.token
      },
      params: options.params
    })

    dispatch({
      type: `LOAD_${entity.toUpperCase()}`,
      response: res.body,
      payload: id
    })


    return res.body;
  }
}

const update = (item, shouldShowSuccessMessage = true) => {
  return async (dispatch, getState) => {
    const state = getState();
    let res = await callApi(`/${entity}/${item.id}`, {
      method: 'PATCH',
      body: JSON.stringify(item),
      headers: {
        token: state.app?.superAdmin?.token
      },
      successMessage: shouldShowSuccessMessage && `Se actualizó ${messageEntity} correctamente.`
    })

    let stored_item = res.body

    dispatch({
      type: `UPDATE_${entity.toUpperCase()}`,
      response: stored_item
    })



  }
}

const remove = item => {
  return async (dispatch, getState) => {
    const state = getState();
    const res = await callApi(`/${entity}/${item.id}`,
      {
        method: 'DELETE',
        headers: {
          token: state.app?.superAdmin?.token
        },
        successMessage: `Se eliminó ${messageEntity} correctamente.`
      })
    dispatch({
      type: `DELETE_${entity.toUpperCase()}`,
      response: res.body
    })
  }
}

const bulkSync = ({ deleteItems, updateItems, createItems }, options = {}) => {
  return async (dispatch, getState) => {
    const state = getState();

    let res = await callApi(`/${entity}/bulkSync`, {
      method: 'POST',
      body: JSON.stringify({
        deleteItems,
        updateItems,
        createItems
      }),
      headers: {
        token: state.app?.superAdmin?.token
      },
      successMessage: `Se sincronizaron ${messagePluralEntity} correctamente.`
    })

    let stored_item = res.body
    return dispatch(load({
      ...options,
      force: true
    }))
  }
}

const getSidebarPinned = (userId) => {
  return async dispatch => {
    const response = await callApi(`/${entity}/${userId}/sidebar_pinned`)
    return response.body
  }
}

const updateSidebarPinned = (userId, sidebar_pinned) => {
  return async dispatch => {
    const response = await callApi(`/${entity}/${userId}/sidebar_pinned`, {
      method: 'PATCH',
      body: { sidebar_pinned }
    })
    return response.body
  }
}

export default { add, load, get, update, remove, bulkSync, prefetchNext, invalidate, getSidebarPinned, updateSidebarPinned }
